// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-layer[data-v-157f04d3]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:100}.loading-layer[data-v-157f04d3] .b-overlay-wrap{width:100%;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
